import { motion } from "framer-motion";

const chapters = [
  { n: "01", title: "A verdade sobre não saber o que postar", desc: "O bloqueio não é falta de criatividade — é falta de processo. Entenda o que realmente está por trás do branco." },
  { n: "02", title: "O que muda quando existe método", desc: "De aleatório para estratégico: como um sistema simples transforma insegurança em clareza." },
  { n: "03", title: "Antes de começar: o mínimo necessário", desc: "Nada de ferramentas caras. O essencial para começar hoje, com o que você já tem." },
  { n: "04", title: "5 passos práticos", desc: "Escolher o ponto de partida, montar o calendário, executar a primeira semana, medir o que importa e ajustar sem recomeçar." },
  { n: "05", title: "Os erros que custam caro", desc: "Os deslizes que afastam clientes e queimam sua energia — e como evitá-los desde o início." },
  { n: "06", title: "Manter o ritmo sem depender de motivação", desc: "Processo vence disciplina: todos os dias da semana. Construa uma rotina que se sustenta sozinha." },
  { n: "07", title: "Do primeiro cliente fixo ao próximo nível", desc: "Encontrar, apresentar, cobrar e reter. O caminho para transformar trabalho em negócio." },
  { n: "08", title: "Os próximos 30 dias", desc: "Um plano curto para não parar: o que fazer, semana a semana, logo depois de virar a última página." },
];

const Chapters = () => (
  <section id="capitulos" data-testid="manifesto-chapters-section" className="relative px-6 py-28 sm:py-36 lg:px-12">
    <div className="mx-auto max-w-7xl">
      <div className="mb-20 flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <motion.p
            className="font-mono-label text-xs uppercase tracking-[0.3em] text-[#D4AF37]"
            initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7 }}
          >
            Dentro do e-book
          </motion.p>
          <motion.h2
            className="font-serif-display mt-6 text-3xl font-semibold leading-tight text-white sm:text-4xl lg:text-5xl"
            initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7, delay: 0.1 }}
          >
            8 capítulos.
            <br />
            <span className="italic text-[#D4AF37]">Um único caminho.</span>
          </motion.h2>
        </div>
        <motion.p
          className="max-w-md text-sm leading-relaxed text-[#A1A1AA] sm:text-base"
          initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7, delay: 0.2 }}
        >
          Nada aqui exige postar por postar. O que exige é seguir a ordem — um capítulo por vez, com exercício e checklist ao final de cada um.
        </motion.p>
      </div>

      <div className="border-t border-[rgba(255,255,255,0.08)]">
        {chapters.map((ch, i) => (
          <motion.div
            key={ch.n}
            data-testid={`chapter-card-${ch.n}`}
            className="group grid grid-cols-[auto_1fr] items-baseline gap-x-8 gap-y-2 border-b border-[rgba(255,255,255,0.08)] py-8 transition-colors duration-500 hover:bg-[rgba(212,175,55,0.04)] sm:grid-cols-[120px_1fr_1fr] sm:gap-x-12 sm:py-10"
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: (i % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
          >
            <span className="font-serif-display text-3xl italic text-[rgba(212,175,55,0.4)] transition-colors duration-500 group-hover:text-[#D4AF37] sm:text-5xl">
              {ch.n}
            </span>
            <h3 className="font-serif-display text-xl font-semibold leading-snug text-white transition-transform duration-500 group-hover:translate-x-2 sm:text-2xl">
              {ch.title}
            </h3>
            <p className="col-span-2 mt-2 text-sm leading-relaxed text-[#71717A] sm:col-span-1 sm:mt-0">
              {ch.desc}
            </p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default Chapters;
